import type { Technique } from '../types';
import { ROOTS_PARAMS } from './params';
import { draw, elementCount, init, isComplete, step, toSVG, type RootsState } from './render';

export const roots: Technique<RootsState> = {
  id: 'roots',
  name: 'Wurzelgeflecht',
  category: 'growth',
  description: 'Wurzeln wachsen aus der Textkontur nach aussen und kreuzen die Buchstaben nie.',
  params: ROOTS_PARAMS,
  renderer: 'canvas2d',
  isAnimated: false,
  init,
  step,
  isComplete,
  draw,
  toSVG,
  elementCount,
};
